import React, { Component, Children, isValidElement, cloneElement } from 'react';
import { Labeled, CardContentInner } from 'react-admin';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Grid from './Grid';

const sanitizeRestProps = ({
    children,
    className,
    record,
    resource,
    basePath,
    version,
    initialValues,
    translate,
    ...rest
}) => rest;

class GridShowLayout extends Component {

	renderChildren = ({ basePath, className, children, record, resource, version, ...rest }) => {
		return Children.map(children, field => {
			if (field && isValidElement(field)) {
				if (field.type === Grid) {
					// In case of a Grid, render it and dive down into the children:
					return (
						<Grid {...field.props}>
							{this.renderChildren({ basePath, className, record, resource, version, ...field.props })}
						</Grid>
					)
				} else {
					// This is the default SimpleGridLayout rendering:
					return (
						<div
							key={field.props.source}
							className={classnames(
								`ra-field ra-field-${field.props.source}`,
								field.props.className
							)}
						>
							{field.props.addLabel ? (
								<Labeled
									record={record}
									resource={resource}
									basePath={basePath}
									label={field.props.label}
									source={field.props.source}
									disabled={false}
									fullWidth={field.props.fullWidth}
								>
									{field}
								</Labeled>
							) : typeof field.type === 'string' ? (
								field
							) : (
								cloneElement(field, {
									record,
									resource,
									basePath,
								})
							)}
						</div>
					)
				}
			} else {
				return null;
			}
		});
	}

	render() {
		const { className, version, ...rest } = this.props;
		return (
			<CardContentInner
    		    className={className}
        		key={version}
        		{...sanitizeRestProps(rest)}
    		>
				{this.renderChildren(rest)}
    		</CardContentInner>
		)
	}
};

GridShowLayout.propTypes = {
    basePath: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    record: PropTypes.object,
    resource: PropTypes.string,
    version: PropTypes.number,
};

export default GridShowLayout;
